import React, { useEffect, useState } from 'react'
import { AccionDetalle, IInitialState, TipoAccionDetalle } from '../../Shared/data/FormReducer';
import { CustomizedSlider, getImageForValue, marksPorcentaje } from '../ModalEvaluacion/constants'

interface Props {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
}

const FormPorcentajeGrasa = ({ state, dispatch }: Props) => {

  const [sliderValue, setSliderValue] = useState<number>(15);
  
  useEffect(() => {
      dispatch({
        type: TipoAccionDetalle.CHANGE_PORCENTAJEGRASA,
        payload: sliderValue,
      });
      dispatch({
        type: TipoAccionDetalle.CHANGE_VALPGRASA,
        payload: false,
      });
  }, [sliderValue])

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setSliderValue(newValue as number);
  };

  const formatValueLabel = (value: number) => {
    const marks = marksPorcentaje;

    const mark = marks.find((mark) => mark.value === value);
    return mark ? mark.textLabel : `${value}%`;
  };

  return (
    <>
      <div className="flex flex-col justify-center items-center">
        <div className="text-center">
          <br />
          <h5 className='font-bold mb-2'>¿Cuál es tu porcentaje de grasa?</h5>
          <p className="text-slate-500">Puedes conocer tu % de grasa en algunas farmacias, gimnasios y hospitales. <br /> ó <br /> Puedes guiarte de manera rápida tomando en cuenta esta imagen de referencia:</p>
        </div>
  
        {/* Imágenes */}
        <div className="flex justify-center items-center w-full">
          {sliderValue && <img src={getImageForValue(sliderValue, state.sexo) || ""} alt="Porcentaje Grasa" style={{ height: "400px" }} />}
        </div>
  
        {/* Slider */}
        <div className="flex justify-center items-center w-[60%]">
          <CustomizedSlider
            aria-label="Custom marks"
            step={5}
            valueLabelDisplay="on"
            min={15}
            max={45}
            marks={marksPorcentaje}
            value={sliderValue}
            valueLabelFormat={formatValueLabel}
            onChange={handleSliderChange}
          />
        </div>
      </div>
    </>
  )
}

export default FormPorcentajeGrasa